import { Injectable } from '@angular/core';
import { AuthService } from '../api/auth.service';
import { Claim } from './claim.enum';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  constructor(
    private auth: AuthService,
  ) { }

  // This method can be called a couple of different ways
  // *hasClaim="'claimType'"  // Assumes claimValue is true
  // *hasClaim="'claimType:value'" // Compares claimValue to value
  // *hasClaim="['claimType1','claimType2:value','claimType3']"
  hasClaim(claimType: any): boolean {
    let ret: boolean = false;

    // See if an array of values was passed in.
    if (typeof claimType === "string") {
      ret = this.isClaimValid(claimType);
    }
    else {
      let claims: string[] = claimType;
      if (claims) {
        for (let index = 0; index < claims.length; index++) {
          ret = this.isClaimValid(claims[index]);
          // If one is successful, then let them in
          if (ret) {
            break;
          }
        }
      }
    }

    return ret;
  }

  private isClaimValid(claim: string): boolean {
    let result: boolean = false;
    let grantedClaims: string[] = [];
    let claimName: string = '';
    let claimValue: string = '';

    // Retrieve granted claims
    // this.store.select(selectGrantedClaims).subscribe(
    //   res => grantedClaims = res
    // );
    const auth = this.auth.getAuth();
    if(auth && auth.grantedClaims){
      grantedClaims = auth.grantedClaims;
    }
    
    if (grantedClaims && grantedClaims.length > 0) {
      // See if the claim type has a value
      // *hasClaim="'claimType:value'"
      if (claim.indexOf(":") >= 0) {
        let words: string[] = claim.split(":");
        claimName = words[0].toLowerCase();
        claimValue = words[1];
      }
      else {
        claimName = claim.toLowerCase();
        // Either get the claim value, or assume 'true'
        claimValue = claimValue ? claimValue : "true";
      }

      // Attempt to find the claim
      result = grantedClaims.find(c => c.toLowerCase() == claimName) != null;
    }

    return result;
  }

  hasProfilePermission(): boolean {
    let claims = [
      Claim.__Profile_Owner, Claim.Profile_View, Claim.Profile_Add, Claim.Profile_Edit, Claim.Profile_Delete,
    ];

    return this.hasClaim(claims);
  }
}
